import React from 'react';
import  { ReactComponent as LoaderSecondary }  from '../../assets/SpinnerBlack.svg'
import './ButtonSecondary.css'


interface Props {
    children?: React.ReactNode;
    type?: any;
    onClick?: () => void;
    style?: React.CSSProperties
    loading?: boolean;
    disabled?: boolean;
    image?: React.ReactNode;
  }

const ButtonSecondary: React.FC<Props> = ({ image, type = "button", children, style, onClick, loading = false, disabled = false}) => {
  return (
    <button 
        type = {type} 
        disabled = {disabled} 
        className='button-secondary-pattern' 
        style={style} 
        onClick={onClick}> 
        {loading ?  <LoaderSecondary className="spinner" /> : 
        (
          <>
            {children}
            {image}
          </>
          
          )
          
        }

    </button>
  );
};

export default ButtonSecondary;